import { callApiNew } from 'src/middleware/apiMiddleware';

const getDefaultAccount = (uuid: string) =>
  callApiNew<BankDetails | CardDetails>({
    endpoint: `/business/${uuid}/default-account`,
  });

// card payment APIs

const getCardSetupIntent = (uuid: string) =>
  callApiNew<CardSetupIntentResponse>({
    endpoint: `/business/${uuid}/card-setup-intent`,
  });

const addCard = (uuid: string, paymentMethodId: string, makeDefault: boolean = true) =>
  callApiNew({
    endpoint: `/business/${uuid}/cards`,
    method: 'POST',
    body: {
      paymentMethodId,
      makeDefault,
    },
  });

// bank payment APIs

const createBankAccount = (uuid: string, bankToken: string, makeDefault: boolean = true) =>
  callApiNew<BankDetails>({
    endpoint: `/business/${uuid}/bank-accounts`,
    method: 'POST',
    body: {
      bankToken,
      makeDefault,
    },
  });

const verifyBankAccount = (uuid: string, data: VerifyBankAccountPayload) =>
  callApiNew({
    endpoint: `/business/${uuid}/verify-bank-account`,
    method: 'POST',
    body: data,
  });

const deleteBankAccount = (uuid: string, bankAccountId: string) =>
  callApiNew({
    endpoint: `/entity/${uuid}/bank-account/${bankAccountId}/delete`,
    params: {
      force: true,
    },
    method: 'DELETE',
  });

const setUpOnboardingBankAccount = (onboardingUuid: string) =>
  callApiNew({
    endpoint: `/onboarding/${onboardingUuid}/setup-bank-account`,
    method: 'POST',
  });

const apiUtil = {
  getDefaultAccount,
  getCardSetupIntent,
  addCard,
  createBankAccount,
  verifyBankAccount,
  deleteBankAccount,
  setUpOnboardingBankAccount,
};

export default apiUtil;
